export default __webpack_public_path__ + "static/media/arivaone4.c6bff82c.jpg";